// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let from_url = ((data) => fetch(data).then(res => res.blob()));

exports.from_url = from_url;
/* No side effect */
